import React, { useEffect, useState } from 'react'
import { getFollowSheet } from '../../core/services/api/patientDiagnosisService'
import "./FlowSheetView.scss"
import moment from 'moment'
export default function FlowSheetView({ patientId, scroll }: any) {
  const [resFlowSheetData, setResFlowSheetData] = useState([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  useEffect(() => {
    // setIsLoading(true)
    if (scroll) {
      scroll()
    }
    getFollowSheet(patientId)
      .then(
        (res) => {
          setResFlowSheetData(res.data)
          setIsLoading(false)
        })
      .catch((err: any) => {
        console.log("err", err)
        setIsLoading(false)
      })
  }, [])

  function concatTumorMarkerString(tumorMarkers: any) {
    let temp = "";
    tumorMarkers?.map((eItm: any, index: any) => temp = temp + (eItm?.tumorMarkerDesc === "other" ? (eItm["tumorMarkerDesc-Comment"] ? eItm["tumorMarkerDesc-Comment"] : "") : eItm?.tumorMarkerDesc) + (index === tumorMarkers?.length - 1 ? "" : ","))
    return temp;
  }

  return (
    <div className="flowsheet">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="heading">FlowSheet</div>
      <div className="flowsheet-content">
        <table className="table-inner">
          <div className="rmo-table">
            <>
              <div className="rmo-label">
                <tr className="rmoLabels">
                  <th> Date</th>
                  <th> Cycle/Day</th>
                  <th> Weight(kg)</th>
                  <th> Height(cm)</th>
                  <th> BSA(m^2)</th>
                  <th> Ecog</th>
                  <th> Protocol</th>
                  <th> Toxicity</th>
                  <th> HB</th>
                  <th> TLC</th>
                  <th> Platelete</th>
                  <th>S.Creat</th>
                  <th>T.Bili</th>
                  <th>SGOT</th>
                  <th>SGPT</th>
                  <th>S.albumin</th>
                  <th>S.Calcium</th>
                  <th>Tumor Marker</th>
                </tr>
              </div>

              {resFlowSheetData?.map((data: any) => (
                <tr className="rmoLabels">
                  <td>{data?.date ? moment(data?.date)?.format("DD-MM-YYYY") : ""}</td>
                  <td>{data?.cycle}</td>
                  <td>{data?.weight}</td>
                  <td>{data?.height}</td>
                  <td>{data?.bsa}</td>
                  <td title={data?.ecog}>{data?.ecog}</td>
                  <td className="tumor-marker" title={data?.regimen}>{data?.regimen}</td>
                  <td className="toxicity-value">{data?.toxicity}</td>
                  <td>{data?.hemoglobin}</td>
                  <td>{data?.wbcCount}</td>
                  <td>{data?.plateletsCount}</td>
                  <td>{data?.serumCreatinine}</td>
                  <td>{data?.totalBilirubinDirect}</td>
                  <td>{data?.sgot}</td>
                  <td>{data?.sgpt}</td>
                  <td>{data?.salbumin}</td>
                  <td>{data?.scalcium}</td>
                  <td className="tumor-marker" title={concatTumorMarkerString(data?.tumorMarkers)}>{concatTumorMarkerString(data?.tumorMarkers)}</td>
                </tr>
              )
              )}
            </>
          </div>
        </table>
      </div>
    </div>
  )
}
